/**
 * @module Components.Wrappers
 *
 */
import { useStoreActions } from "app/utils/hooks";
import React, { memo, useContext } from "react";
import Authenticated from "./Authenticated";
import Loading from "./Loading";
import SiteWrapper from "../Layouts/SiteWrapper";
import { useHistory } from "react-router-dom";
import i18n from "app/i18n";
import { fetchSelf } from "app/actions/user";
import { UserContext } from "app/contexts/UserContext";
import { isRouteAllowed, RouteAccessRule } from "./routeAccess";

interface IPrivateRouteProps extends RouteAccessRule {
  children: React.ReactNode;
  ignoreReturn?: boolean;
  trialNotAllowed?: boolean;
}

function PrivateRoute(props: IPrivateRouteProps) {
  const { user } = useStoreActions({ user: fetchSelf });
  const pending = user?.pending || user?.data == null;
  const history = useHistory();
  const userContext = useContext(UserContext);
  // A route with a role rule waits for the account before it mounts its page
  // (CN-2813): otherwise a scheduler typing /spaces would see the page and
  // fire its requests for the instant before the redirect below.
  let mountPage = !props.access || !pending;

  if (!pending && user) {
    i18n.changeLanguage(user?.data?.locale);

    if (!isRouteAllowed(props, user?.data?.features, userContext)) {
      mountPage = false;
      history.push("/");
    }
  }

  return (
    <Authenticated>
      <SiteWrapper>
        {mountPage ? (
          props.children
        ) : (
          <Loading isLoading loadType="spinner" />
        )}
      </SiteWrapper>
    </Authenticated>
  );
}

export default memo(PrivateRoute);
